/**
 * BFP-1119 — tenant from survey instrument definition for platform KYC config + redeem
 * when SP JWT has no tenant claims (mirrors mobile `LoggingSession` survey tenant fields).
 */

const TENANT_ID_KEY = 'brushfire_sp_survey_tenant_id'
const TENANT_SUBDOMAIN_KEY = 'brushfire_sp_survey_tenant_subdomain'

export interface SurveyTenantContext {
  tenantId: string
  tenantSubdomain: string
}

function readSession(key: string): string {
  if (globalThis.sessionStorage === undefined) return ''
  try {
    return globalThis.sessionStorage.getItem(key)?.trim() ?? ''
  } catch {
    return ''
  }
}

function writeSession(key: string, value: string) {
  if (globalThis.sessionStorage === undefined) return
  try {
    const trimmed = value.trim()
    if (trimmed) {
      globalThis.sessionStorage.setItem(key, trimmed)
    } else {
      globalThis.sessionStorage.removeItem(key)
    }
  } catch {
    /* private mode / quota */
  }
}

export function getSurveyTenantContext(): SurveyTenantContext {
  return {
    tenantId: readSession(TENANT_ID_KEY),
    tenantSubdomain: readSession(TENANT_SUBDOMAIN_KEY),
  }
}

export function hasSurveyTenantContext(): boolean {
  const ctx = getSurveyTenantContext()
  return ctx.tenantId.length > 0 && ctx.tenantSubdomain.length > 0
}

export function applySurveyTenantContext(ctx: SurveyTenantContext): void {
  writeSession(TENANT_ID_KEY, ctx.tenantId)
  writeSession(TENANT_SUBDOMAIN_KEY, ctx.tenantSubdomain)
}

export function clearSurveyTenantContext(): void {
  writeSession(TENANT_ID_KEY, '')
  writeSession(TENANT_SUBDOMAIN_KEY, '')
}
